import {NgIf}                   from '@angular/common';
import {Component, Input}       from '@angular/core';
import {LetDirective, PushPipe} from '@ngrx/component';
import {Store}                  from '@ngrx/store';
import {HistoryStats}           from '@shared/classes/historyStats';
import {User}                   from '@shared/classes/user';
import {BreadcrumbEnum}         from '@shared/enums/breadcrumb.enum';
import {SelectionEnum}          from '@shared/enums/selection.enum';
import {DynamicComponent}       from 'src/app/components/shared/dynamic/dynamicComponent/dynamic.component';
import {createHistory}          from 'src/app/shared/ngrx/store/actions/history.actions';
import {selectCurrentproduct}   from 'src/app/shared/ngrx/store/selectors/bilan.selector';
import {selectCaisse}           from 'src/app/shared/ngrx/store/selectors/config.selector';
import {IBilanState}            from 'src/app/shared/ngrx/store/state/bilan.state';
import {QueryParams}            from 'src/app/shared/queryParams/queryParams';
import {LocalStorageUtil}       from 'src/app/shared/utils/localStorageUtil';
import {DYNAMIC_COMPONENTS}     from '../../../../shared/dynamic/dynamicComponent/dynamicComponent.constants';

@Component ({
              selector:    'app-produit-caroussel',
              templateUrl: './produit-caroussel.component.html',
              styleUrls:   ['./produit-caroussel.component.scss'],
              standalone:  true,
              imports:     [
                NgIf,
                PushPipe,
                DynamicComponent,
                LetDirective,
              ],
              providers:   [],
            })
export class ProduitCarousselComponent {
  @Input ()
  queryParams: QueryParams;

  @Input ()
  user: User;

  public currentProduit$     = this._store.select (selectCurrentproduct);
  public currentCaisse$      = this._store.select (selectCaisse);
  public readonly components = DYNAMIC_COMPONENTS;

  constructor (private _store: Store<IBilanState>) {
  }

  history (titleVideo: string) {
    const history          = new HistoryStats (LocalStorageUtil.getUserId (), BreadcrumbEnum.DIAGNOSTIC, this.queryParams.PROFIL, SelectionEnum.SCREEN);
    history.selection_type = SelectionEnum.VIDEO;
    history.infos          = titleVideo;
    this._store.dispatch (createHistory ({historyStats: history}));
  }

}
